import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ completed, next_position, position, card_index, house }) {
        return (
            <spread-card
              onmousedown={this.pick}
              class={!completed && next_position === card_index ? 'next' : ''}
              house={house}
              orientation={position.orientation}
            >
                {this.renderTitle(position)}
                {this.renderSpreadCardContent(card_index)}
            </spread-card>
        );
    }

    renderTitle = (position) => {
        if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.spread.length > 8) { //no titles on view 1
            return null;
        }

        if (position.title) {
            return (
                <h3 class='position-name'>{position.title.replace(/\/.*/, '')}</h3>
            );
        }

        return null;
    }

    renderSpreadCardContent = (card_index) => {
        if (this.props.card) {
            if (this.props.upc == 'yes-or-no-tarot-redux') {
                if (this.props.spread.length > 8 && card_index == 0) { //Show the Wheel of Fortune card (pre-selected)
                    return (
                        <img alt={this.props.card.name} src={this.props.card.images.full} />
                    );
                }

                //Show the back for all other cards
                return [
                    <img
                      alt='card back'
                      src={'https://gfx.tarot.com/images/site/tarot/' + this.props.upc + '/card-back.svg'}
                    />,
                    <p class='card-name' />,
                ];
            }

            return [
                <img alt={this.props.card.name} src={this.props.card.images.full} />,
                <p class='card-name'>{this.props.card.name}</p>,
            ];
        }

        return [
            <div class='outline' />,
            <p class='card-name' />,
        ];
    }

    pick = () => {
        const available_ids = this.props.spread.filter(cardId => cardId != 'picked');
        const card_index = Math.floor(Math.random() * available_ids.length);
        const card_id = available_ids[card_index];

        if (this.props.completed) {
            if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.spread.length > 8) {
                document.querySelector('button[data-action="Click-Shuffle-Cards-Button"]').click();
                return;
            }

            this.props.tarotFetch();
            return;
        }

        this.props.tarotPicked(card_id);
        this.props.deckSpread(card_id);
    }
}

const mapStateToProps = (state, props) => ({
    card: state.deck && state.deck.cards[props.card_id],
    completed: state['tarot-reading'].cards.length === state['tarot-reading'].positions.length,
    next_position: state['tarot-reading'].cards.length,
    spread: state.deck.spread,
    upc: state.product && state.product.teeup.code,
});

const mapDispatchToProps = (dispatch) => ({
    tarotFetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    deckSpread: (card_id) => dispatch({ type: 'deck:spread', payload: card_id }),
    tarotPicked: (card_id) => dispatch({ type: 'tarot-reading:picked', payload: { card: card_id, source: 'Layout' } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/spread-card.js